module.exports = __webpack_public_path__ + "static/Janowo_Park_III_01_V04_nav-5daa5602fe705ac57894cf5b09a872fe.jpg";